import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Pencil: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.30329 9.5536L1.26758 14.7322L6.44615 13.6965L14.4284 5.71409C14.8329 5.30962 14.8329 4.65384 14.4284 4.24937L11.7502 1.57124C11.3458 1.16677 10.6901 1.16677 10.2856 1.57124L2.30329 9.5536Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
